import { NumberOfContests } from 'apps/BWW_PLAY_HUB/components/HubStats/NumberOfContests';
import { fetchHubStats } from 'apps/BWW_PLAY_HUB/modules/actions/hub_stats';
import { useDispatch, useSelector } from 'react-redux';
import { NavigationHubStats } from 'apps/BWW_PLAY_HUB/components/HubStats/NavigationHubStats';
import { RewardPoints } from 'apps/BWW_PLAY_HUB/components/HubStats/RewardPoints';
import { DaysPlayed } from 'apps/BWW_PLAY_HUB/components/HubStats/DaysPlayed';
import { TopPercentsPP } from 'apps/BWW_PLAY_HUB/components/HubStats/TopPercentsPP';
import { UserNumberPerfectContests } from 'apps/BWW_PLAY_HUB/components/HubStats/UserNumberPerfectContests';
import { UserMonthlyHighestPoints } from 'apps/BWW_PLAY_HUB/components/HubStats/UserMonthlyHighestPoints';
import { DailyRewardPoints } from 'apps/BWW_PLAY_HUB/components/HubStats/DailyRewardPoints';
import { HubStatsItems } from 'apps/BWW_PLAY_HUB/components/HubStats/styles';
import React, { Fragment, useEffect, useRef, } from 'react';
import styled from 'styled-components';
import { getHubFilter, getHubStats, getHubStatsFetched } from 'apps/BWW_PLAY_HUB/modules/selectors/hub_stats';
import icon_arr from 'apps/BWW_PLAY_HUB/assets/img/icon_arr.svg';
import { EnumFiltersHubStats } from 'apps/BWW_PLAY_HUB/modules/utils/enums';
import { EnumStatsType } from 'apps/BWW_PLAY_HUB/components/HubStats/utils';


const HubStatsWrapper = styled.div`
  padding-top: 40px;
  padding-bottom: 76px;
  position: relative;
`;

const HideStats = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface IHubStats {
	is_stats_show: boolean;
	toggleShowStats: () => void;
	setStatsHeight: (height: number) => void;
}

export const HubStats: React.FC<IHubStats> = ({is_stats_show, toggleShowStats, setStatsHeight}) => {
	const dispatch = useDispatch();

	const hubStats = useSelector(getHubStats);
	const currentFilter = useSelector(getHubFilter);
	const is_hub_stats_fetched = useSelector(getHubStatsFetched);
	const hubStatsWrapperRef = useRef<HTMLDivElement>(null);

	const is_overview = currentFilter === EnumFiltersHubStats.All;
	const is_pp = currentFilter === EnumFiltersHubStats.PicksAndProps;

	useEffect(() => {
		setStatsHeight(hubStatsWrapperRef?.current?.offsetHeight || 0);
	}, [hubStats, setStatsHeight, currentFilter]);

	useEffect(() => {
		if (is_stats_show && !is_hub_stats_fetched) {
			dispatch(fetchHubStats());
		}
	}, [dispatch, is_stats_show, is_hub_stats_fetched]);

	return (
		<HubStatsWrapper ref={hubStatsWrapperRef}>
			<NavigationHubStats/>
			<HubStatsItems>
				{is_overview && (
					<Fragment>
						<RewardPoints/>
						<NumberOfContests/>
						<TopPercentsPP/>
						<DaysPlayed/>
					</Fragment>
				)}
				{is_pp && (
					<Fragment>
						<UserNumberPerfectContests/>
						<UserMonthlyHighestPoints/>
						<DailyRewardPoints type={EnumStatsType.pp}/>
					</Fragment>
				)}
			</HubStatsItems>

			<HideStats onClick={toggleShowStats}>
				<img src={icon_arr} alt={'Hide stats'}/>
			</HideStats>
		</HubStatsWrapper>
	);
};
